var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":"","fill-width":""}},[_c('v-card',{attrs:{"height":"100%","fill-height":"","fill-width":"","width":"100%"}},[_c('div',{staticStyle:{"height":"1000px"},attrs:{"id":"placeholder"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }